import { useNotifications } from 'modules/app/notifications';
import { logger } from 'src/utils/datadog-log-wrapper';

import { useTranslation } from '../hooks/useTranslation';

export const CopyableText = ({
  value,
  className = '',
}: {
  value: string;
  className?: string;
}) => {
  const { t } = useTranslation('global');

  const { successNotif } = useNotifications();

  return (
    <div
      role="button"
      tabIndex={0}
      className={`flex cursor-pointer flex-row items-center justify-between rounded-12 px-16 py-8 body-m hover:bg-background-primary-hover [&_div]:invisible [&_div]:hover:visible ${className}`}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.currentTarget.click();
        }
      }}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value);
          successNotif(t('misc.textCopiedToClipboard'));
        } catch {
          logger.info('Failed to copy text', {
            team: 'travel-and-expenses',
            scope: 'card::billing-address',
          });
        }
      }}
    >
      {value}
      <div className="text-content-brand-default">{t('misc.copy')}</div>
    </div>
  );
};
